module.exports = __webpack_public_path__ + "img/CRT_Bow 002.6fb7fc1f.png";